exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-text {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/mediate/src/app/video/video.component.css
// module id = ../../../../../src/app/video/video.component.css
// module chunks = main